import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useDocumentMeta } from '@/lib/useDocumentMeta';

// Stripe redirects here on successful subscription checkout. We deliberately
// do NOT trust the URL params for the "active" state — the webhook is the
// source of truth. We just bounce the user back to /app after a beat,
// passing along ?checkout=success so the dashboard can poll the
// subscription endpoint a few extra times in case the webhook is slow.
export default function SuccessPage() {
  useDocumentMeta({ title: 'Payment Confirmed — Cash Forth' });

  useEffect(() => {
    const t = setTimeout(() => {
      window.location.href = '/app?checkout=success';
    }, 2500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center px-6"
      data-testid="checkout-success-page"
    >
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-12 h-12 rounded-full border border-green-500/40 flex items-center justify-center text-green-600 mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-6 h-6"
            aria-hidden="true"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight text-black">
          Your subscription is active.
        </h1>
        <p className="mt-3 text-sm text-gray-600">
          Taking you back to Cash Forth…
        </p>
        <div className="mt-8">
          <Button
            onClick={() => { window.location.href = '/app?checkout=success'; }}
            data-testid="checkout-success-return-btn"
            className="bg-black text-white hover:bg-black/85 rounded-md px-6"
          >
            Go to dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
